import script from "./MessageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageHeader.vue?vue&type=script&setup=true&lang=js"

import "./MessageHeader.vue?vue&type=style&index=0&id=ab292558&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab292558"]])

export default __exports__